// Tipos do módulo Tarefas (espelham tabelas tarefas / tarefa_participantes).

export type TarefaStatus =
  | "a_fazer"
  | "em_andamento"
  | "aguardando"
  | "concluida"
  | "cancelada";

export type TarefaPrioridade = "baixa" | "media" | "alta" | "urgente";

export type TarefasView = "home" | "lista" | "kanban" | "calendario";

export interface TarefaProfileMini {
  id: string;
  nome: string;
  email?: string | null;
}

export interface TarefaClienteMini {
  id: number;
  nome: string;
  telefone?: string | null;
}

export interface TarefaParticipante {
  tarefa_id: string;
  user_id: string;
  created_at?: string;
  profile?: TarefaProfileMini | null;
}

export interface Tarefa {
  id: string;
  titulo: string;
  descricao: string | null;
  status: TarefaStatus;
  prioridade: TarefaPrioridade;
  prazo: string | null;
  responsavel_id: string;
  criado_por: string;
  cliente_id: number | null;
  concluida_em: string | null;
  created_at: string;
  updated_at: string;
  responsavel?: TarefaProfileMini | null;
  criador?: TarefaProfileMini | null;
  cliente?: TarefaClienteMini | null;
  participantes?: TarefaParticipante[];
}

export interface TarefaInput {
  titulo: string;
  descricao?: string | null;
  status?: TarefaStatus;
  prioridade?: TarefaPrioridade;
  prazo?: string | null;
  responsavel_id: string;
  cliente_id?: number | null;
  participante_ids?: string[];
}

export const TAREFA_STATUS_LABEL: Record<TarefaStatus, string> = {
  a_fazer: "A fazer",
  em_andamento: "Em andamento",
  aguardando: "Aguardando",
  concluida: "Concluída",
  cancelada: "Cancelada",
};

export const TAREFA_STATUS_COLOR: Record<TarefaStatus, string> = {
  a_fazer: "bg-[#F3F4F6] text-[#374151] border-[#E5E7EB]",
  em_andamento: "bg-[#252D30] text-white border-[#1A2022]",
  aguardando: "bg-[#C9C9C9] text-[#1F2937] border-[#9CA3AF]",
  concluida: "bg-[#1A2022] text-white border-[#111827]",
  cancelada: "bg-red-50 text-red-700 border-red-200",
};

export const TAREFA_PRIORIDADE_LABEL: Record<TarefaPrioridade, string> = {
  baixa: "Baixa",
  media: "Média",
  alta: "Alta",
  urgente: "Urgente",
};

export const TAREFA_PRIORIDADE_COLOR: Record<TarefaPrioridade, string> = {
  baixa: "bg-slate-100 text-slate-600 border-slate-200",
  media: "bg-blue-50 text-blue-700 border-blue-200",
  alta: "bg-amber-50 text-amber-800 border-amber-200",
  urgente: "bg-red-50 text-red-700 border-red-200",
};

export const KANBAN_COLUNAS_TAREFAS: TarefaStatus[] = [
  "a_fazer",
  "em_andamento",
  "aguardando",
  "concluida",
  "cancelada",
];

export const STATUS_ABERTOS: TarefaStatus[] = [
  "a_fazer",
  "em_andamento",
  "aguardando",
];
